export default "__VITE_ASSET__C0D_0w9w__"